export default __webpack_public_path__ + "static/media/TheNewYorkTimeLogo.465f3a07.png";